var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-xs text-brand-text-secondary",attrs:{"data-component":"CsFormHelpText"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }